export const SUCCESS_AUTH="SUCCESS_AUTH";
export const FAILED_AUTH="FAILED_AUTH";
export const REQUST_AUTH="REQUST_AUTH";
export const SUCCESS_LOGOUT="SUCCESS_LOGOUT";
